
import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items?: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();

  // デフォルトのパンくずリストを生成
  const generateDefaultBreadcrumbs = (): BreadcrumbItem[] => {
    const pathnames = location.pathname.split('/').filter((x) => x);
    
    const breadcrumbs: BreadcrumbItem[] = [
      { label: 'ホーム', href: '/' }
    ];

    const routeMap: { [key: string]: string } = {
      'about': '当社について',
      'services': 'サービス',
      'inspection-flow': '車検の流れ',
      'pricing': '費用',
      'careers': '採用情報',
      'contact': 'お問い合わせ'
    };

    pathnames.forEach((pathname) => {
      const label = routeMap[pathname] || pathname;
      breadcrumbs.push({
        label,
        href: `/${pathname}`
      });
    });

    return breadcrumbs;
  };

  const breadcrumbItems = items || generateDefaultBreadcrumbs();

  // ホームページでは表示しない
  if (location.pathname === '/') {
    return null;
  }

  return (
    <nav className="bg-gray-50 py-3 border-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ol className="flex items-center space-x-2 text-sm">
          {breadcrumbItems.map((item, index) => (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-gray-400 mx-2"></i>
              )}
              {item.href && index < breadcrumbItems.length - 1 ? (
                <Link
                  to={item.href}
                  className="text-gray-600 hover:text-orange-500 transition-colors duration-200 cursor-pointer"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-slate-800 font-medium">
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}
